import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { sharedStore } from "../../../../stores/SharedStore";
import { AnimationType } from "../../../../../shared/resources/AnimationAssetModel";
import { gameStore } from "../../../../stores/GameStore";
const Container = styled.div.withConfig({
  displayName: "AnimationSelectionDetail__Container",
  componentId: "sc-1k5zmob-0"
})(["display:flex;flex-direction:column;width:100%;"]);
const Row = styled.div.withConfig({
  displayName: "AnimationSelectionDetail__Row",
  componentId: "sc-1k5zmob-1"
})(["display:flex;flex-direction:row;margin-top:4px;"]);
const RowLabel = styled.div.withConfig({
  displayName: "AnimationSelectionDetail__RowLabel",
  componentId: "sc-1k5zmob-2"
})(["min-width:100px;"]);
const Select = styled.select.withConfig({
  displayName: "AnimationSelectionDetail__Select",
  componentId: "sc-1k5zmob-3"
})(["width:100%;"]);
export const AnimationSelectionDetail = observer(({
  animationProp: animationProp
}) => {
  const {
    t
  } = useTranslation();
  const allAnimations = Array.from(sharedStore.animationAssets.values()).filter(animation => animation.isType(AnimationType.Cutscene));
  const selectedAnimation = sharedStore.getAnimationByName(animationProp.value);

  function onAnimationSelected(animationId) {
    animationProp.setValue(animationId);
  }

  function onAnimationSequenceSelected(animationSequence) {
    animationProp.setSequence(animationSequence);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, t("action_editor.property_name")), /*#__PURE__*/React.createElement(Select, {
    value: animationProp.value ? animationProp.value : "",
    onChange: ({
      target
    }) => onAnimationSelected(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "-"), allAnimations.map(animation => /*#__PURE__*/React.createElement("option", {
    key: animation.name,
    value: animation.name
  }, animation.localizedName.get(gameStore.languageKey))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(RowLabel, null, t("action_editor.property_sequence")), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
    value: animationProp.sequence ? animationProp.sequence : "",
    onChange: ({
      target
    }) => onAnimationSequenceSelected(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "-"), selectedAnimation && selectedAnimation.animationNames.map(state => /*#__PURE__*/React.createElement("option", {
    key: state,
    value: state
  }, state))))));
});